export const TEMPLATE_AUTOSAVE_REQUESTED = 'BUSINESS:TEMPLATE_AUTOSAVE_REQUESTED';
export const templateAutosaveRequested = (immediately) => ({
    type: TEMPLATE_AUTOSAVE_REQUESTED,
    payload: { immediately },
});
